if (!window.StoreSwitcher) {
  class StoreSwitcher extends HTMLElement {
    constructor() {
      super();

      document.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(e) {
      const storeSwitcher = e.target.closest(".store-switcher");
      document.querySelectorAll(".store-switcher").forEach((switcher) => {
        if (switcher !== storeSwitcher) {
          switcher.classList.remove("is-active");
        }
      });

      if (storeSwitcher && storeSwitcher == this) {
        storeSwitcher.classList.toggle("is-active");
      }
    }
  }
  window.StoreSwitcher = StoreSwitcher;
  customElements.define("store-switcher", StoreSwitcher);
}
